import React, { useState } from "react";
import { Link } from "react-router-dom";
import { List, ListItemButton, ListItemText, Menu } from "@mui/material";
import AngleIcon from "assets/images/icons/AngleIcon";
import { BASE_SITE_URL } from "config";

const HeaderAttract = () => {
  const [headerMenuEl, setHeaderMenuEl] = useState(null);
  const headerMenuOpen = Boolean(headerMenuEl);
  const headerMenuOpenReq = (event: any) => {
    setHeaderMenuEl(event.currentTarget);
  };
  const headerMenuClose = () => {
    setHeaderMenuEl(null);
  };

  return (
    <>
      <div
        className={`meeting6ix-layout-header-right-item-btn meeting6ix-layout-header-right-item-btn-full ${
          headerMenuOpen ? "active" : ""
        }`}
        id="header-attract-menu-button"
        aria-controls={headerMenuOpen ? "header-attract-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={headerMenuOpen ? "true" : undefined}
        onClick={headerMenuOpenReq}
      >
        <div className="meeting6ix-layout-header-right-item-btn-text">
          Attract Capital
        </div>
        {headerMenuOpen ? <AngleIcon up /> : <AngleIcon small />}
      </div>

      <Menu
        id="header-attract-menu"
        anchorEl={headerMenuEl}
        open={headerMenuOpen}
        onClose={headerMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-attract-menu-button",
        }}
        className="meeting6ix-layout-header-right-item-dropdown meeting6ix-layout-header-right-item-dropdown-users"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List
          component="nav"
          className="meeting6ix-layout-header-right-item-dropdown-users-list"
        >
          <a
            className="MuiButtonBase-root MuiListItemButton-root MuiListItemButton-gutters MuiListItemButton-root MuiListItemButton-gutters meeting6ix-layout-header-right-item-dropdown-users-list-item"
            href="https://leads.6ix.com"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="meeting6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Get Leads"
            />
          </a>

          <a
            className="MuiButtonBase-root MuiListItemButton-root MuiListItemButton-gutters MuiListItemButton-root MuiListItemButton-gutters meeting6ix-layout-header-right-item-dropdown-users-list-item"
            href={`${BASE_SITE_URL}/create`}
            onClick={headerMenuClose}
          >
            <ListItemText
              className="meeting6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Host Events"
            />
          </a>
          <a
            className="MuiButtonBase-root MuiListItemButton-root MuiListItemButton-gutters MuiListItemButton-root MuiListItemButton-gutters meeting6ix-layout-header-right-item-dropdown-users-list-item"
            href={process.env.REACT_APP_SITE_URL}
            onClick={headerMenuClose}
          >
            <ListItemText
              className="meeting6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Schedule Meetings"
            />
          </a>
        </List>
      </Menu>
    </>
  );
};

export default HeaderAttract;
